export default __webpack_public_path__ + "static/1-24d1a929bfab036bad5808ad73c0fb1e.jpg";